const privateRoutes = [
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/private/Dashboard.vue"),
    },
    {
        path: "/messages",
        name: "messages",
        component: () => import("../views/private/Messages.vue"),
    },
    {
        path: "/messages/contact",
        name: "contact",
        component: () => import("../views/private/messages/Contact.vue"),
    },
    {
        path: "/messages/referent-handicap",
        name: "referent-handicap",
        component: () => import("../views/private/messages/Handicap.vue"),
    },
    {
        path: "/dossier",
        name: "file",
        component: () => import("../views/private/File.vue"),
    },
    {
        path: "/dossier/mes-tests",
        name: "mes-tests",
        component: () => import("../views/Test.vue"),
    },
    {
        path: "/dossier/candidature/informations_personnelles",
        name: "ma-candidature-1",
        component: () => import("../views/private/formulaire/InformationsPersonnelles.vue"),
    },
    {
        path: "/dossier/candidature/parcours_professionnel",
        name: "ma-candidature-2",
        component: () => import("../views/private/formulaire/ParcoursProfessionnel.vue"),
    },
    {
        path: "/dossier/candidature/enregistrement_dossier",
        name: "ma-candidature-3",
        component: () => import("../views/private/formulaire/EnregistrementDossier.vue"),
    },
    {
        path: "/questionnaire/:type",
        name: "questionnaire",
        component: () => import("../views/private/questionnaire/Commencer.vue"),
    },
    {
        path: "/questionnaire/:type/question",
        name: "question",
        component: () => import("../views/private/questionnaire/Question.vue"),
    },
    {
        path: "/mon-profil",
        name: "profil",
        component: () => import("../views/private/Profil.vue"),
    }
];
export default privateRoutes;
